import c from "../../utils/constants";
import env from "../../utils/env";

// TODO: Look for a cleaner solution.
let requestsVm;

class JobRequestsController {
  constructor(JobRequestsService, FilterService, AuthService, UsersService, $scope) {
    "ngInject"

    this.usersService = UsersService;
    this.jobRequestsService = JobRequestsService;
    this.filterService = FilterService;
    this.authService = AuthService;
    this.$scope = $scope;
    this.jobRequestsDataSource = this.jobRequestsService.getDataSource(this.dataSourceFetchSuccessCallback.bind(this), this.dataSourceErrorSuccessCallback.bind(this))
    this.gridOptions = this.getGridOptions();
    requestsVm = this;
  }

  getGridOptions() {
    return {
      dataSource: this.jobRequestsDataSource,
      sortable: true,
      pageable: true,
      resizable: true,
      height: "90vh",
      noRecords: {
        // template: "No match found. Change your filter criteria."
        template: "None yet."
      },
      columns: [
        {
          field: "requestDate", title: "Request Date", filterable: false, width: "4rem",
          template: `<span>#= kendo.toString(new Date(requestDate), 'dd-MM-yyyy') #</span>`,
        },
        {
          field: "ownerFullName", title: "Job Owner", filterable: false, sortable: false,width: "6rem",
          template: `<a class="cell" href="#= '/users/' + ownerUserId #">#= ownerFullName #</a>`,
        },
        { field: "jobType", title: "Job Type", filterable: false, sortable: false, width: "4rem", template: (dataItem) => `${this._getJobTypeText(dataItem.jobType)}` },
        { field: "id", title: "Request #", filterable: false, sortable: false, width: "2rem", template: (dataItem) => `#${dataItem.id}` },
        {
          field: "scheduledCallLocalTime", title: "Briefing Call", filterable: false, width: "4rem",
          template: (dataItem) => this._getScheduledDate(dataItem),
        },
        { field: "jobRequestStatus", title: "Status", filterable: false, sortable: false, width: "4rem", template: (dataItem) => `${this._getJobRequestStatusText(dataItem.jobRequestStatus)}` },
        // {
        //   field: "state", title: "State", filterable: false, width: "4rem",
        //   template: `<span>#= (country === 'au' ? state.toUpperCase() : state) #</span>`,
        // },
        { title: "Update", command: [{ name: "edit", text: "Update" }], width: "4rem" },
        // { title: 'Post Job', command: { text: "Post Job", click: this.handlePostJob }, width: "4rem" },
        { title: 'Transfer Job', command: { text: "Transfer Job", click: this.handleTransferJob }, width: "4rem" },
      ],
      editable: {
        mode: "popup",
        window: { title: "Update" },
        template: kendo.template($("#popup-editor").html())
      }
    }
  }

  // https://demos.telerik.com/kendo-ui/grid/custom-command

  handleTransferJob(e) {
    e.preventDefault();

    var dataItem = this.dataItem($(e.currentTarget).closest("tr"));

    if (dataItem.jobRequestStatus != c.jobRequestStatus.JOB_POSTED) {
      alert('Job can only be transfered after it has been posted. ');
      return;
    }

    if (confirm('Are you sure that you would like to finalise this job and transfer it to the parent? This action is irreversible.')) {
      requestsVm.jobRequestsService.transferJob(dataItem, () => {
        requestsVm.jobRequestsDataSource.read();
      });
    } else {
      console.log('no-transfer');
    }
  }

  handlePostJob(e) {
    e.preventDefault();

    var dataItem = this.dataItem($(e.currentTarget).closest("tr"));

    if (dataItem.jobRequestStatus != c.jobRequestStatus.CALL_SCHEDULED) {
      alert('Only requests in a scheduled call status can be posted. ');
      return;
    }
    const jobManagerId = dataItem.jobManagerId;

    requestsVm.loginAsUser(2, jobManagerId);
  }

  loginAsUser(targetDevice, userId) {
    this.usersService.getLoginAsUserAccessToken(userId,
    (response) => {
      console.log("Access token::", response.data);
      this.redirectToTarget(targetDevice, response.data.accessToken, 'au');
    },
    (error) => {

    });
  }

  redirectToTarget(targetDevice, token, country) {
    const rootUrl = env.getLoginAsBaseUrl(targetDevice, country);
    var url = rootUrl + `?admin_mode=1&access_token=${token}`;
    console.log(url);
    window.open(rootUrl + `?admin_mode=1&access_token=${token}`);
  }

  applyFilters() {
    this.gridOptions.dataSource.filter(this.filterService.getAppliedFilters());
  }

  dataSourceFetchSuccessCallback(e) {
    this.jobsMatchCount = this.gridOptions.dataSource.total();
    this.$scope.$apply();
  }

  dataSourceErrorSuccessCallback(e) {
    if (e.xhr.status == 401) {
      this.authService.refreshToken().then((response) => {
        this.applyFilters();
      }).catch((error) => {
        this.authService.logout();
      });
    } else {
      this.authService.logout();
    }
  }

  _getScheduledDate(dataItem) {
    if (!dataItem.scheduledCallLocalTime) return 'N/A';

    return kendo.toString(new Date(dataItem.scheduledCallLocalTime), 'dd/MM @ hh:mmtt');
  }

  _getJobRequestActions(dataItem) {
    // <span class='k-icon k-i-edit'></span>
    // const postJobAction = "<a role='button' class='k-button k-button-icontext k-grid-edit' href='##'>Post Job</a>";
    const transferJobAction = "<a role='button' class='k-button k-button-icontext k-grid-edit' href='##'>Transfer Job</a>";
    const notesAction = "<a role='button' class='k-button k-button-icontext k-grid-edit' href='##'>Notes</a>";

    return `<span>${transferJobAction}${notesAction}</span>`;
  }

  _getHelperStats(dataItem) {
    return dataItem.activeInvites + " / "  + dataItem.totalInvites;
  }

  _getOpenRate(dataItem) {
    const activity = dataItem.activeInvites + " / "  + dataItem.totalInvites;
    const openRate = dataItem.activeInvites / dataItem.totalInvites;
    return kendo.format('{0:p0}', openRate);
  }

  _getJobTypeText(type) {
    switch(type) {
      case c.jobType.BABYSITTING:
        return "Babysitting";
      case c.jobType.NANNYING:
        return "Nannying";
      case c.jobType.AFTER_SCHOOL_CARE:
        return "After School Care";
      case c.jobType.BEFORE_SCHOOL_CARE:
        return "Before School Care"
      case c.jobType.BEFORE_AFTER_SCHOOL_CARE:
        return "Before/After School Care";
      case c.jobType.AU_PAIR:
        return "Au Pair";
      case c.jobType.PRIMARY_SCHOOL_TUTORING:
        return "Primary School Tutoring";
      case c.jobType.HIGH_SCHOOL_TUTORING:
        return "High School Tutoring";
      case c.jobType.ONE_OFF_ODD_JOBS:
        return "Odd Job";
    }
  }

_getJobRequestStatusText(status) {
    switch(status) {
      case c.jobRequestStatus.NEW_REQUEST:
        return "New Request";
      case c.jobRequestStatus.CALL_SCHEDULED:
        return "Call Scheduled";
      case c.jobRequestStatus.JOB_POSTED:
        return "Job Posted";
      case c.jobRequestStatus.JOB_TRANSFERRED:
        return "Job Transferred";
      case c.jobRequestStatus.JOB_AWARDED:
        return "Job Awarded";
    }
  }

  _getManagedByText(status) {
    switch (status) {
      case c.managedBy.USER:
        return "DIY";
      case c.managedBy.SYSTEM:
        return "Assist";
    }

    return "";
  }

}

export default JobRequestsController;



/** WEBPACK FOOTER **
 ** E:/JUGGLE_STREET/Juggle-Street-Deployment-All/JSBIGFOOTFRONTEND-BACKEND/admin-frontend/client/app/containers/job-requests/job-requests.controller.js
 **/